import React, { useState } from "react";
import {
  Container,
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Avatar,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import PolicyIcon from "@mui/icons-material/Policy";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import AppHeader from "../components/AppHeader";
import { auth, uploadImage, updateUserProfile } from "../firebase";
import { endSession } from "../session";
import { useAuthUser } from "../hooks/useAuthUser";
import { useNavigate } from "react-router-dom";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import logo from "../imgs/logo.png";

const Profile = () => {
  const navigate = useNavigate();
  const { user, profile } = useAuthUser();
  const [loading, setLoading] = useState(false);
  const [localImageUrl, setLocalImageUrl] = useState(null);

  const profileImageUrl = localImageUrl || profile?.profileImageUrl;
  const displayName = profile?.displayName || "";
  const email = profile?.email || "";

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !auth.currentUser) return;
    setLoading(true);
    try {
      const imageUrl = await uploadImage(file);
      await updateUserProfile(auth.currentUser.uid, { profileImageUrl: imageUrl });
      setLocalImageUrl(imageUrl);
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setLoading(false);
    }
  };

  const onLogout = async () => {
    try {
      await endSession();
    } finally {
      navigate("/login");
    }
  };

  const menuItems = [
    { label: "Editar Perfil", icon: <SettingsIcon />, href: "/edit" },
    { label: "Términos y Condiciones", icon: <AutoStoriesIcon />, href: "/terms" },
    { label: "Política y Privacidad", icon: <PolicyIcon />, href: "/privacyPolicy" },
  ];

  return (
    <Container disableGutters>
      <AppHeader variant="back" title="Mi perfil" user={user} />
      <Container sx={{ pt: 10, pb: 4, maxWidth: "sm" }}>
        <Paper sx={{ p: 3, display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <Box sx={{ position: "relative" }}>
            <Avatar src={profileImageUrl} alt="Perfil" sx={{ width: 72, height: 72 }} />
            <input
              type="file"
              accept="image/*"
              onClick={(event) => (event.target.value = null)}
              onChange={handleImageUpload}
              style={{ display: "none" }}
              id="upload-button"
            />
            <IconButton
              component="span"
              size="small"
              onClick={() => document.getElementById("upload-button").click()}
              sx={{
                position: "absolute",
                bottom: -4,
                right: -4,
                bgcolor: "background.paper",
                boxShadow: 1,
                "&:hover": { bgcolor: "background.paper" },
              }}
            >
              {loading ? <CircularProgress size={18} /> : <AddPhotoAlternateIcon fontSize="small" />}
            </IconButton>
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" noWrap>
              {displayName}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {email}
            </Typography>
          </Box>
        </Paper>

        <Paper>
          <List disablePadding>
            {menuItems.map((item) => (
              <ListItemButton key={item.href} onClick={() => navigate(item.href)}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
            <ListItemButton onClick={onLogout}>
              <ListItemIcon>
                <ExitToAppIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Cerrar sesión" sx={{ color: "error.main" }} />
            </ListItemButton>
          </List>
        </Paper>
      </Container>
      <FloatingWhatsApp
        phoneNumber="+542323680787"
        placeholder="Escribe un mensaje..."
        statusMessage="Responde en menos de 10 minutos"
        accountName="IntelliChallenge"
        avatar={logo}
        chatMessage="Hola!¿Cómo estás?¿En que puedo ayudarte?😃"
      />
    </Container>
  );
};

export default Profile;
